import './css/styles.scss';

function boendeKortInit() {}

boendeKortInit();
